module.exports = __webpack_public_path__ + "../resources/img/img_check_72.b72236be.svg";